export default "__VITE_ASSET__fe57de14__"